import React from 'react';
import styled from 'styled-components';
import LoadingSpinner from '../LoadingSpinner';
import Color from '@/utils/color';

type BasicButtonProps = {
  color?: string;
  small: boolean;
  inline?: boolean;
};

const BasicButton = styled.button<BasicButtonProps>`
  background: ${({ color, theme }) => color || (theme as any).color.primary};
  color: #fff;
  border-radius: 5px;
  border-width: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: pre;
  padding: 0.5rem 1rem;
  cursor: pointer;
  &:disabled {
    background: ${Color.MudGrey};
  }
  ${(props) =>
    props.small &&
    `
    font-size: 12px;
    padding: 5px 10px;
    `}
  ${(props) => props.inline && `display: inline-block;`}
`;

const Container = styled.div`
  display: flex;
  white-space: pre;
`;

type ButtonProps = {
  children: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
  small?: boolean;
  color?: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
};

function Button({
  children,
  disabled = false,
  loading = false,
  small = false,
  color,
  onClick,
  ...rest
}: ButtonProps) {
  return (
    <BasicButton
      {...rest}
      color={color}
      type="button"
      small={small}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading && <LoadingSpinner size={1} sizeUnit="rem" />}
      <Container>{children}</Container>
    </BasicButton>
  );
}

export default Button;
